const timeFrameBarOptions = {
  display: 'flex',
  alignItems: 'center',
};

export { timeFrameBarOptions };
